import { useCallback, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { getPersonOtherInfo } from '../services/personService'
import useNotifications from './useNotifications'

export default function useOtherInfo(personId) {
  const { t } = useTranslation()
  const { error } = useNotifications()
  const [otherInfo, setOtherInfo] = useState()

  const fetchOtherInfo = useCallback(() => {
    if (personId) {
      getPersonOtherInfo(personId)
        .then((resp) => {
          if (resp.status === 200) {
            setOtherInfo(resp.data)
          }
        })
        .catch((err) => {
          error(
            t('hooks.errors.gettingOtherInfoForPerson', {
              defaultValue: `Error getting other info for a person: ${err.message || ''}`,
              message: err.message || '',
            }),
            err
          )
        })
    }
  }, [error, personId, t])

  useEffect(() => {
    fetchOtherInfo()
  }, [fetchOtherInfo])

  return { otherInfo }
}
